module.exports = __webpack_public_path__ + "static/sport/logo.99ef792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/logo.png
// module id = wAE1
// module chunks = 0